import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import {
  getTerminals,
  updateTerminal,
  addNewTerminal,
  deleteTerminal,
} from '../../../actions/company'
import { getShopList } from '../../../actions/shop'
import { openErrorMessage } from '../../../actions/message'

// utils
import { sortArrayByName } from '../../../utils/array'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import TerminalItemContainer from '../../../components/Terminals/TerminalItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'

const emptyTerminal = {
  name: '',
  enabled: false,
  shopId: '',
}

class CompanyTerminals extends PureComponent {
  state = {
    showEmptyTerminal: false,
    selectedToDeleteTerminal: {},
  }

  componentDidMount() {
    this.props.dispatch(getTerminals())
    this.props.dispatch(getShopList())
  }

  onTerminalUpdate = (data, afterOnSave) => {
    if (this.validateTerminal(data)) {
      Appcues.track('Company Terminal updated')
      this.props.dispatch(updateTerminal(data)).then((response) => {
        this.props.dispatch(getTerminals())
        afterOnSave(response)
      })
    }
  }

  openDeleteModal = (terminal) => (e) => {
    this.setState({
      selectedToDeleteTerminal: terminal,
    })

    this.deleteModal.handleClickOpen()
  }

  onDeleteTerminal = (terminal) => (e) => {
    this.deleteModal.handleClose()

    this.props.dispatch(deleteTerminal(terminal.id)).then((response) => {
      Appcues.track('Company Terminal deleted')
      this.props.dispatch(getTerminals())
    })
  }

  toogleEmptyTerminal = () => {
    Appcues.track('Adding Company Terminal')
    this.setState((prevState) => ({
      showEmptyTerminal: !prevState.showEmptyTerminal,
    }))
  }

  addNewTerminal = (data, afterOnSave) => {
    if (this.validateTerminal(data)) {
      Appcues.track('Company Terminal saved')
      this.props.dispatch(addNewTerminal(data)).then((terminal) => {
        this.props.dispatch(getTerminals())
        this.toogleEmptyTerminal()
      })
    }
  }

  validateTerminal = (terminal) => {
    if (!terminal.name) {
      this.props.dispatch(openErrorMessage('Please enter terminal name'))
      return false
    }

    return true
  }

  render() {
    const { shopsList = {} } = this.props.shopReducer

    const { terminals = {}, lastModified = null } = this.props.companyReducer

    const { showEmptyTerminal, selectedToDeleteTerminal } = this.state

    const terminalsValues = sortArrayByName(terminals.values)
    const shopValues = shopsList.values || []

    const activeshops = shopValues.filter((shop) => shop.active)

    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.toogleEmptyTerminal}
              >
                Add Terminal
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Terminal Name</TableCell>
                      <TableCell>Device Name</TableCell>
                      <TableCell>Assigned shop</TableCell>
                      <TableCell>Status</TableCell>
                      {hasAccess() ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyTerminal ? (
                      <TerminalItemContainer
                        terminal={emptyTerminal}
                        lastModified={lastModified}
                        onTerminalUpdate={this.addNewTerminal}
                        shops={activeshops}
                        onCancel={this.toogleEmptyTerminal}
                        defaultEditMode={true}
                      />
                    ) : null}
                    {terminalsValues.map((row, index) => {
                      return (
                        <TerminalItemContainer
                          key={index}
                          terminal={row}
                          lastModified={lastModified}
                          onTerminalUpdate={this.onTerminalUpdate}
                          shops={activeshops}
                          onDelete={this.openDeleteModal(row)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            onConfirm={this.onDeleteTerminal(selectedToDeleteTerminal)}
            confirmText="delete"
          >
            Are you sure you want to delete '{selectedToDeleteTerminal.name}'
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
}))(ContainerWithTitle(CompanyTerminals, 'Company Terminals'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyTerminals.js